var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Foundation / Icons /alert/triangle_lg@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tax-Information-Reload-Minimized-View---Mobile",
    transform: "translate(-29.000000, -746.000000)",
    fill: "#258AFB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 585.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Info-Alert-with-Copy-/-x-/-Master",
    transform: "translate(16.000000, 137.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Triangle",
    transform: "translate(13.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5462285,22.0583404 C23.7572074,22.4406687 23.7490523,22.9115849 23.5154159,23.28929 C23.266255,23.6920926 22.8077324,23.9127736 22.3405833,23.8597631 L1.35728988,23.8597631 C0.890140791,23.9127736 0.431618175,23.6920926 0.182457286,23.28929 C-0.0667548594,22.8864045 -0.0594194144,22.3774657 0.196760301,21.9831098 L10.8229536,0.731774753 C11.3108025,-0.243923086 12.3870707,-0.243923086 12.8749141,0.731763766 L23.5011129,21.9831098 L23.5462285,22.0583404 Z M22.4081589,22.6189416 L22.434408,22.6206129 L22.4213108,22.5980874 L11.8489366,1.45560889 L1.27656233,22.5980874 L1.26346516,22.6206129 L1.28971427,22.6189416 L22.4081589,22.6189416 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4696262,16.3968917 L12.4696262,9.0238509 C12.4696262,8.68105347 12.191734,8.40316125 11.8489366,8.40316125 C11.5061391,8.40316125 11.2282469,8.68105347 11.2282469,9.0238509 L11.2282469,16.3968917 C11.2282469,16.7396891 11.5061391,17.0175813 11.8489366,17.0175813 C12.191734,17.0175813 12.4696262,16.7396891 12.4696262,16.3968917 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8606338,17.8828953 L11.8272612,17.8828953 C11.5913561,17.887541 11.3671996,17.9867393 11.2051311,18.1582226 C11.0430625,18.3297059 10.9566661,18.559101 10.965344,18.7948921 C10.9832328,19.2508084 11.3399688,19.6148433 11.7867773,19.6483019 L11.8584162,19.6508102 C12.106517,19.6460542 12.3306736,19.5468559 12.4927421,19.3753726 C12.6548106,19.2038893 12.7412071,18.9744942 12.7325292,18.7387032 C12.7140833,18.2665121 12.3316979,17.8917743 11.8606338,17.8828953 Z",
    id: "Path"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOutline);
export default __webpack_public_path__ + "static/media/warning-outline.f282639227dda7ff2ebbe6de9e17e55f.svg";
export { ForwardRef as ReactComponent };